import { useState, useCallback } from 'react';
import { BaseSlideGroupProps } from '../../../../../../types/SlideGroupProps';

export const useSlideGroupBase = (props: BaseSlideGroupProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleDeleteGroup = useCallback(() => {
    props.onDeleteSlideGroup(props.slideGroup.id);
  }, [props.onDeleteSlideGroup, props.slideGroup.id]);

  const handleMoveUp = useCallback(() => {
    if (props.slideGroup.index !== 0) {
      props.onUpdateSlideGroupOrder(props.slideGroup.index, 'left');
    }
  }, [props.onUpdateSlideGroupOrder, props.slideGroup.index]);

  const handleMoveDown = useCallback(() => {
    if (!props.isLastGroup) {
      props.onUpdateSlideGroupOrder(props.slideGroup.index, 'right');
    }
  }, [
    props.onUpdateSlideGroupOrder,
    props.slideGroup.index,
    props.isLastGroup,
  ]);

  return {
    isExpanded,
    setIsExpanded,
    handleDeleteGroup,
    handleMoveUp,
    handleMoveDown,
  };
};
